<template>
  <div class="header">
    <div class="actions" v-if="!currentUserIsOwner">
      <MessageButton
        v-if="connectionStatus === 'connected'"
        @openMessenger="openMessenger"
      />
      <AcceptRejectButtons
        v-if="connectionStatus === 'pending' && requesterID !== userID"
        :profileOwnerID="profileOwnerID"
        :userID="userID"
        :connectionID="connectionID"
        @updateConnectionStatus="$emit('updateConnectionStatus', $event)"
      />
      <ConnectButton
        v-else-if="connectionStatus !== 'blocked'"
        :currentUserSentRequest="requesterID === userID"
        :profileOwnerID="profileOwnerID"
        :userID="userID"
        :connectionID="connectionID"
        :connectionStatus="connectionStatus"
        :isExcluded="isExcluded"
        @unexcludingComplete="unexcludingComplete"
        @updateConnectionStatus="$emit('updateConnectionStatus', $event)"
      />
    </div>
    <div @click="editProfile" class="edit" v-if="currentUserIsOwner"
      >Edit profile</div
    >
    <div v-if="isNick" class="crown-medal-container">
      <ik-image
        loading="lazy"
        :transformation="[{ height: 500, width: 500 }]"
        v-if="profileImageUrl"
        :src="profileImageUrl"
        class="image"
      />
      <div v-else class="image smallBorder">
      <IconBase
        icon-name="profile"
        iconColor="#333"
        viewBox="0 0 32 32"
        width="100%"
        height="100%"
        strokeWidth="0px"
        ><IconProfileImg
      /></IconBase>
    </div>
      <ik-image
        loading="lazy"
        :transformation="[{ height: 500, width: 500 }]"
        src="https://ik.imagekit.io/elysiumone/Badges/Badges__12__JbPuf-GP00.png"
        class="crown"
      />
    </div>
    <div v-if="hasMedal" class="crown-medal-container">
      <ik-image
        loading="lazy"
        :transformation="[{ height: 500, width: 500 }]"
        v-if="profileImageUrl"
        :src="profileImageUrl"
        class="image"
      />
      <div v-else class="image smallBorder">
      <IconBase
        icon-name="profile"
        iconColor="#333"
        viewBox="0 0 32 32"
        width="100%"
        height="100%"
        strokeWidth="0px"
        ><IconProfileImg
      /></IconBase>
    </div>
      <ik-image
        loading="lazy"
        :transformation="[{ height: 500, width: 500 }]"
        src="https://ik.imagekit.io/elysiumone/Badges/Badges__9__lY0eiYhmb.png"
        class="medal"
      />
    </div>
    <ik-image
      loading="lazy"
      :transformation="[{ height: 500, width: 500 }]"
      v-if="profileImageUrl && !hasMedal && !isNick"
      :src="profileImageUrl"
      class="image"
    />
    <div v-else-if="!profileImageUrl && !hasMedal && !isNick" class="image smallBorder">
      <IconBase
        icon-name="profile"
        iconColor="#333"
        viewBox="0 0 32 32"
        width="100%"
        height="100%"
        strokeWidth="0px"
        ><IconProfileImg
      /></IconBase>
    </div>
    <div class="title">
      <h1>{{ profileDisplayName }}</h1>
    </div>
    <!-- <div class="myrooms-sub">View and manage all of your rooms</div> -->
    <div class="section">
      <div class="sessionCount">
        {{ sessionCountString }}
      </div>
    </div>
    <div class="section">Joined: {{ getProfileJoinedDate }}</div>
    <div class="section">
      <div v-html="profileUserBio"></div>
    </div>
    <!-- <div class="section">
      <div class="attendanceScore" v-if="currentUserIsOwner && profile.attendanceScore">
        {{ `Attendance score: ${profile.attendanceScore}%` }}
      </div> -->
    <!-- <div>Send Match Request</div> -->

    <!-- <div class="viewProfile">View my public profile</div>
        <div class="newRoom" @click="createNewRoom">+ New room</div> -->
    <!-- </div> -->
    <!-- <div>Connect</div> -->
    <!-- <div v-html="profile.bio"></div> -->
  </div>
</template>

<script>
import { format } from "date-fns";
import IconBase from "../../../components/IconBase";
import IconProfileImg from "../../../components/SVG/IconProfileImg";
import ConnectButton from "./ConnectButton";
import MessageButton from "./MessageButton";
import AcceptRejectButtons from "./AcceptRejectButtons";
import SettingsMethods from '../../../ELYX/Settings/SettingsMethods';

export default {
  name: "ProfileHeader",
  components: {
    IconBase,
    IconProfileImg,
    ConnectButton,
    MessageButton,
    AcceptRejectButtons,
  },
  props: {
    userID: String,
    profileOwnerID: String,
    currentUserIsOwner: Boolean,
    sessionCount: Number,
    profileDisplayName: String,
    profileImageUrl: String,
    profileUserJoinedDate: Date,
    profileUserBio: String,
    connectionStatus: String,
    requesterID: String,
    connectionID: String,
    isExcluded: Boolean,
    isNick: Boolean,
    hasMedal: Boolean,
  },
  computed: {
    sessionCountString() {
      let sessionCountText = "";
      if (!this.sessionCount) sessionCountText = "No sessions yet";
      else if (this.sessionCount > 1)
        sessionCountText = `${this.sessionCount} Sessions`;
      else if (this.sessionCount < 2 && this.sessionCount > 0)
        sessionCountText = `${this.sessionCount} Session`;

      return sessionCountText;
    },
    getProfileJoinedDate() {
      return format(new Date(this.profileUserJoinedDate), `MMM d, y`);
    },
  },
  methods: {
    openMessenger() {
      this.$emit("openMessenger", this.profileOwnerID);
    },
    unexcludingComplete() {
      this.$emit("unexcludingComplete");
    },
    editProfile() {
      SettingsMethods.openSettingsModal();
    }
  },
};
</script>

<style scoped>
.crown-medal-container {
  position: relative;
}
.crown {
  position: absolute;
  bottom: 60px;
  left: 60px;
  width: 150px;
  height: 150px;
  transform: rotate(45deg);
}
.medal {
  position: absolute;
  bottom: -50px;
  left: 50px;
  width: 150px;
  height: 150px;
  transform: rotate(350deg);
}
</style>